import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'

import HowItWorks from 'components/_special/HowItWorks'
import KitScience from 'components/_special/KitScience'
import Publications from 'components/_special/Publications'
import ProductTextLineBanner from 'components/_special/ProductTextLineBanner'
import TrustpilotReviews from 'components/_special/TrustpilotReviews'
import FullSizeVideoBlock from 'components/FullSizeVideoBlock'
import StoriesSlider from 'components/StoriesSlider'
import WillLearn from 'components/WillLearn'
import { RU, UK, BE, NL, IE, US } from 'constants/countries'
import { GOODS_TYPES } from 'constants/sales'
import { DEVELOPMENT } from 'constants/environments'
import { cityAdsMicrobiomePage } from 'constants/cityAdsScripts'
import CartSaleWideContainer from 'containers/CartSaleWideContainer'
import DistributionBannerContainer from 'containers/DistributionBannerContainer'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'
import { biomeResults, biomeHowItWorks } from 'routes'
import { LastBlock } from 'styles/components/layout'
import useCurrentPromoEvent from 'hooks/useCurrentPromoEvent'
import { HowItWorks as HowItWorksNew } from 'widgets/HowItWorks'
import { OrderTestWidget } from 'widgets/OrderTestWidget'

import BAboutFirstBlock from './components/BAboutFirstBlock'
import BAboutQuestions from './components/BAboutQuestions'
import BAboutSubscription from './components/BAboutSubscription'
import BAboutDemo from './components/BAboutDemo'
import { SecondBlock, ThirdBlock } from './styles'
import Intro from '../DnaAbout/components/Intro'
import HeaderPad from '../DnaAbout/components/HeaderPad'

const BiomeAbout = ({ texts, publications, stories, pathCdn, pathShared }) => {
  const secondBlock = React.useRef()
  const { mobile, tablet } = React.useContext(ResizeContext)
  const { locale, paths, dict } = React.useContext(LocalizationContext)

  const isUk = React.useMemo(() => locale === UK, [locale])
  const isUs = locale === US

  //костыль для серверного рендера, блоки которые зависят от акций должны полностью ререндериться
  const [IntroRenderSource, setIntroRenderSource] = useState('server')
  useEffect(() => {
    setIntroRenderSource('client')
  }, [])

  //для акций UK странички аналогичны RU
  const event = useCurrentPromoEvent(locale)

  return (
    <>
      {(process.env.NODE_ENV !== DEVELOPMENT && locale === RU)
        && <Helmet><script id='xcntmyAsync' type='text/javascript'>{cityAdsMicrobiomePage}</script></Helmet>
      }
      {locale === RU || isUs ? (
        <>
          <HeaderPad />
          <Intro
            key={`Intro-Microbiome-${IntroRenderSource}-render`}
            translations={{
              ...texts.first,
              title: texts.first.title || texts.first.title_consultation,
            }}
            goodsType={GOODS_TYPES.biome}
          />
        </>
      ) : (event && event.countries.includes(locale) && event.withStyledProductPages)
        ? (
          <div>
            <HeaderPad />
            <Intro
              key={`Intro-Microbiome-${IntroRenderSource}-render`}
              translations={{
                ...texts.first,
                title: texts.first.title || texts.first.title_consultation,
              }}
              goodsType={GOODS_TYPES.biome}
            />
          </div>)
        : (
          <BAboutFirstBlock
            key={`FirstBlock-Microbiome-${IntroRenderSource}-render`}
            data={texts.first}
            secondBlockRef={secondBlock}
          />
        )
      }

      <ProductTextLineBanner />

      {[UK, BE, NL, IE].includes(locale) && (
        <TrustpilotReviews />
      )}

      <SecondBlock ref={secondBlock}>
        <FullSizeVideoBlock
          cover={`${paths.shared}/youtube_biome_cover`}
          isMobile={mobile}
          data={texts.discover_world}
        />
      </SecondBlock>

      <ThirdBlock>
        <WillLearn
          data={texts.will_learn}
          mobile={mobile}
          tablet={tablet}
          link={biomeResults.link(locale)}
        />
      </ThirdBlock>

      <BAboutSubscription
        pathShared={pathShared}
        pathCdn={pathCdn}
        data={texts.subscription}
      />

      {isUk || isUs && (
        <BAboutDemo
          texts={{ title: texts.video_title, body: texts.video_body }}
        />
      )}

      {isUs ? (
        <HowItWorksNew className='my-6' texts={dict.how_it_works_section} />
      ) : (
        <HowItWorks
          data={texts.how_works}
          coverUrl={`${paths.cdn_global}/common_hiw/hiw/how_the_test_works`}
          link={biomeHowItWorks}
        />
      )}

      <KitScience data={texts.science} mobile={mobile} tablet={tablet} />

      {/*{locale === RU && (*/}
      {/*  <FullSizeVideoBlock*/}
      {/*    isTextInnerOnMobile={true}*/}
      {/*    cover={`${paths.shared}/ted_video_cover`}*/}
      {/*    isMobile={mobile}*/}
      {/*    data={texts.tedx}*/}
      {/*  />*/}
      {/*)}*/}

      {stories && stories.list && (
        <StoriesSlider
          slides={stories.list}
          isMobile={mobile}
          path={paths.cdn_global}
          locale={locale}
        />
      )}
      {/* TODO: Временно скрытый блок с публикациями */}
      {/* <Publications
        isMobile={mobile}
        list={(publications && publications.list) || []}
        logos={`${paths.shared}/publications_logo`}
      /> */}

      <BAboutQuestions isMobile={mobile} data={texts.faq} />

      {isUs ? (
        <OrderTestWidget
          className='pb-md-6'
          productType={GOODS_TYPES.biome}
          commonTexts={dict}
        />
      ) : (
        <LastBlock>
          <CartSaleWideContainer productType={GOODS_TYPES.biome} />

          <DistributionBannerContainer />
        </LastBlock>
      )}
    </>
  )
}

BiomeAbout.propTypes = {
  language: PropTypes.string.isRequired,
  texts: PropTypes.object.isRequired,
  publications: PropTypes.object,
  stories: PropTypes.object,
  pathCdn: PropTypes.string,
  pathShared: PropTypes.string,
}

export default BiomeAbout
